jQuery(document).ready(function($) {

	var $header = $('#header');
		$nav 	= $('#nav');

});
